const userPermissions = (state = null, action) => {
    if (action.type === "SET_USER_PERMISSION") {
        return action.payload;
    } else {
        return state;
    }
};

export default userPermissions;
